import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CloseIcon from '@mui/icons-material/Close';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';

function LearnUnitsDialog({ open, onClose, learnUnits = [] }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth>
      <DialogTitle>
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <Stack direction='row' spacing={1} alignItems='center'>
            <MenuBookOutlinedIcon />
            <Typography variant='h6' fontWeight='bold'>
              Unidades de aprendizaje
            </Typography>
          </Stack>
          <IconButton edge='end' color='inherit' onClick={onClose} aria-label='close'>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        {learnUnits.length === 0 ? (
          <Typography variant='body2'>Sin unidades de aprendizaje asociadas.</Typography>
        ) : (
          <React.Fragment>
            <Typography variant='subtitle2'>
              Esta pregunta esta asociada a las siguientes unidades de aprendizaje:
            </Typography>
            <List dense>
              {learnUnits.map(unit => (
                <ListItem key={unit.id} disableGutters>
                  <ListItemIcon sx={{ minWidth: 32 }}>
                    <SchoolOutlinedIcon fontSize='small' />
                  </ListItemIcon>
                  <ListItemText primary={unit.name} />
                </ListItem>
              ))}
            </List>
          </React.Fragment>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default LearnUnitsDialog;
